// Host-visible AI fields — must match the drawer AI Fields section (excludes fuel).
export const HOST_AI_FIELD_KEYS = ['name', 'type', 'instructions', 'entrance', 'surface'];
